<template>
    <div class="service">
        <!-- <img :src="service" alt=""> -->
        <img src="../assets/service/service.png" alt="">
        <span>长按二维码识别添加售后客服</span>
        <p>客服坐席时间: 早上9点 - 夜间10点</p>
        <p>客服热线: 400 005 9926</p>
        <!-- <div class="service-tips">
            <span>云南地区使用须知：</span>
            <em>尊敬的客户，您好，因云南地区使用有激活报备流程，激活后48-72小时可正常上网使用！有疑问的请联系客服进行咨询及处理！</em>
        </div> -->
    </div>
</template>

<script>
    export default {
        name: "Service",
        // data(){
            // return{
                // service: '',
                // serviceImages: [
                //     require("../assets/service/service1.png"),
                //     require("../assets/service/service2.png"),
                //     require("../assets/service/service3.png"),
                //     require("../assets/service/service4.png"),
                // ],
                // lastServiceIndex: -1, // 记录上一次显示的图片索引
                // intervalId: null // 存储定时器 ID
            // }
        // },
        // mounted() {
        //     this.switchServiceImage(); // 页面加载时切换图片
        //     this.startImageRotation(); // 启动图片自动更换
        // },
        // beforeDestroy() {
        //     clearInterval(this.intervalId); // 清除定时器
        // },
        // methods: {
        //     switchServiceImage() {
        //         let randomIndex;
        //         do {
        //             randomIndex = Math.floor(Math.random() * this.serviceImages.length);
        //         } while (randomIndex === this.lastServiceIndex); // 确保选择不同的索引

        //         this.service = this.serviceImages[randomIndex];
        //         this.lastServiceIndex = randomIndex; // 更新上一次显示的索引
        //     },

        //     startImageRotation() {
        //         this.intervalId = setInterval(() => {
        //             this.switchServiceImage(); 
        //         }, 30000);
        //     }
        // }
    }
</script>

<style scoped>
    .service{
        width: 400px;
        margin: 50px auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    img{
        /* width: 300px;
        height: 300px; */
        display: block;
        cursor: pointer;
    }
    span{
        margin-top: 20px;
        font-size: 14px;
    }
    p{
        color: coral;
        margin-bottom: 0px;
    }
    p:first-of-type{
        display: block;
        margin-top: 30px;
    }
    .service-tips{
        width: 300px;
        margin-top: 15px;
        font-size: 14px;
        color: black;
        display: flex;
        flex-direction: column;
        text-align: left;
    }
    .service-tips em{
        font-style: normal;
        margin-top: 10px;
    }
</style>